import BasicHeader from "pages/MaterialSpecs/components/BasicHeader/BasicHeader";
import React, { useCallback, useEffect, useState } from "react";
import { useMaterialSpecs } from "pages/MaterialSpecs/hooks";
import { useSelector } from "react-redux";
import { getMaterialDetailsById } from "store/features/materialSpecs/specs";
import { LoadingOverlay } from "components";
import { PreviousMaterialVersion } from "pages/MaterialSpecs/components/InfoPanel/Versions/PreviousMaterialVersion/PreviousMaterialVersion";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead } from "@material-ui/core";
import { useVersions } from "hooks/api/useVersions";
import { MaterialSpecTableRowHeader } from "pages/MaterialSpecs/components";
import { INFO_PANEL_OFFSET } from "styles/utils";
import { useTranslation } from "react-i18next";

export const Versions = () => {
    const { t } = useTranslation();
    const { selectedMaterialSpecId, selectedMaterialId, isPrinted, select } = useMaterialSpecs();
    const materialDetails = useSelector(getMaterialDetailsById(selectedMaterialSpecId, selectedMaterialId));
    const [selectedVersionId, setSelectedVersionId] = useState<number | undefined>();
    const { isFetching, data: previousVersions } = useVersions(selectedMaterialSpecId);

    useEffect(() => {
        setSelectedVersionId(selectedMaterialId);
        // eslint-disable-next-line
    }, []);

    const handleVersionSelect = useCallback(
        (id: number) => {
            if (selectedMaterialSpecId) {
                setSelectedVersionId(id);
                // update providers data about selected material
                select(true, selectedMaterialSpecId, id);
            }
        },
        [select, selectedMaterialSpecId]
    );

    if (!isPrinted || !selectedMaterialId || !selectedMaterialSpecId || !previousVersions) {
        return null;
    }

    return (
        <LoadingOverlay active={isFetching}>
            <BasicHeader
                bookedDimensions={materialDetails?.bookedSize}
                modificationDate={materialDetails?.modificationDate}
                dimensions={materialDetails?.dimensions}
            />
            <TableContainer component={Paper} style={{ maxHeight: `calc(100% - ${INFO_PANEL_OFFSET}px` }}>
                <Table stickyHeader>
                    <TableHead>
                        <MaterialSpecTableRowHeader>
                            <TableCell />
                            <TableCell>{t("campaign.versions.label.version")}</TableCell>
                            <TableCell />
                            <TableCell>{t("campaign.versions.label.modificationTime")}</TableCell>
                            <TableCell>{t("campaign.versions.label.fileName")}</TableCell>
                            <TableCell>{t("campaign.versions.label.size")}</TableCell>
                            <TableCell />
                        </MaterialSpecTableRowHeader>
                    </TableHead>
                    <TableBody>
                        {previousVersions.map((previousVersion) => (
                            <PreviousMaterialVersion
                                key={previousVersion.id}
                                permissions={materialDetails?.permissions}
                                materialSpecId={selectedMaterialSpecId}
                                selectedMaterialId={selectedMaterialId}
                                previousVersion={previousVersion}
                                selected={previousVersion.id === selectedVersionId}
                                onVersionSelect={handleVersionSelect}
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </LoadingOverlay>
    );
};
